import React from "react";

const Navbar = () => {
  return (
    <nav className="bg-white px-6 sm:px-8 lg:px-12 w-full py-3 z-20 start-0 border-b border-orange-200 shadow-sm">
      <div className="max-w-screen-xl flex items-center justify-between mx-auto">
        {/*
          The "Student Reviews" button was removed. It was the most prominent
          control on a page whose only job is to get the form completed, and it
          opened a different site — an exit route offered to someone who had
          already decided to buy. Nothing in this nav should compete with the
          form now.

          The logo is deliberately not a link either, for the same reason.
        */}
        {/* Logo links home by owner's decision (2026-08-25) — the earlier
            no-exit-from-checkout stance is overridden. */}
        <a href="https://www.sajawal.school" className="flex items-center border-none p-0 m-0">
          <img
            src="/checkout/images/saj-logo.png"
            alt="Sajawal School"
            className="h-12 sm:h-14 md:h-16 w-auto p-0 m-0"
          />
        </a>
        <div className="flex items-center gap-2 text-gray-500">
          <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
          <span className="font-poppins text-xs sm:text-sm font-semibold whitespace-nowrap">
            Secure enrollment
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
